import { FC, useState } from "react";
import { correctSVG, loadingSVG } from "../../../assets/SVGs/SVGs";
import { Button, Modal } from "antd";
import OverViewModalWrapper from "./modal/OverViewModalWrapper";
import { TbLoader } from "react-icons/tb";
import { FormattedMessage, useIntl } from "react-intl";
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../../services/react-query/queryKeys";
import { useSelector } from "react-redux";
import { getLocation } from "../../../network/location";

interface OverViewInfoProps {}

const OverViewInfo: FC<OverViewInfoProps> = ({}) => {
  const [openModal, setOpenModal] = useState(false);
  const intl = useIntl();
  const phrases = [
    intl.formatMessage({ id: "phrase_0" }),
    intl.formatMessage({ id: "phrase_1" }),
    intl.formatMessage({ id: "phrase_2" }),
    intl.formatMessage({ id: "phrase_3" }),
  ];
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number | null } }) => state.calendar
  );
  const { data: locationDetails, isLoading } = useQuery(
    ["locationDetails", locationId],
    () => getLocation(locationId),
    {
      enabled: !!locationId,
      select: (res) => res?.data,
    }
  );

  const isDocumentsUploaded = (): boolean => {
    if (!locationDetails) {
      return false;
    }
    let flag = true;
    const documents = [
      "work_permit",
      "insurance_document",
      "compliance_regulation",
    ];
    documents.forEach((doc) => {
      const exists = locationDetails?.settings?.find(
        (item: { key: string }) => item.key === doc
      );
      if (!exists) {
        flag = false;
      }
    });
    return flag;
  };
  return (
    <div className="flex flex-col justify-center gap-8 h-full">
      <div className="space-y-4">
        <h1 className="text-2xl font-bold text-color-primary">
          <FormattedMessage id="discoverSalonOnlinePresence" />
        </h1>
        <p className="text-[#75757E]">
          <FormattedMessage id="buildCommunity" />
        </p>
      </div>
      <div>
        {phrases.map((phrase, i) => (
          <p
            key={i}
            className="text-color-primary font-semibold flex gap-2 items-center"
          >
            <span className=" md:self-end ">{correctSVG}</span>
            <span className=" leading-8 ">{phrase}</span>
          </p>
        ))}
      </div>
      <div className="">
        {isDocumentsUploaded() ? (
          <Button
            type="text"
            htmlType="button"
            className="px-2 bg-[#B0B0C0] flex justify-center h-12 gap-2 items-center"
            disabled
          >
            <TbLoader color="white" size={20} />
            <span className="text-white">
              <FormattedMessage id="checkingSalonForOnlineListing" />
            </span>
          </Button>
        ) : (
          <Button
            type="primary"
            htmlType="button"
            className="py-4 px-12"
            loading={isLoading}
            onClick={() => setOpenModal(true)}
          >
            <FormattedMessage id="startNow" />
          </Button>
        )}
        <Modal
          open={openModal}
          destroyOnClose
          maskClosable={false}
          onOk={() => setOpenModal(false)}
          onCancel={() => setOpenModal(false)}
          footer={null}
          width={850}
          rootClassName="modal-white-bg"
          style={{ top: 10 }}
        >
          <OverViewModalWrapper />
        </Modal>
      </div>
    </div>
  );
};

export default OverViewInfo;
